/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordVaultAuthorizationRequest
 */
export interface RecordVaultAuthorizationRequest {
    /**
     * 
     * @type {string}
     * @memberof RecordVaultAuthorizationRequest
     */
    termsVersion: string;
    /**
     * 
     * @type {any}
     * @memberof RecordVaultAuthorizationRequest
     */
    termsSnapshot: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof RecordVaultAuthorizationRequest
     */
    acceptedTerms: boolean;
}

/**
 * Check if a given object implements the RecordVaultAuthorizationRequest interface.
 */
export function instanceOfRecordVaultAuthorizationRequest(value: object): value is RecordVaultAuthorizationRequest {
    if (!('termsVersion' in value) || value['termsVersion'] === undefined) return false;
    if (!('termsSnapshot' in value) || value['termsSnapshot'] === undefined) return false;
    if (!('acceptedTerms' in value) || value['acceptedTerms'] === undefined) return false;
    return true;
}

export function RecordVaultAuthorizationRequestFromJSON(json: any): RecordVaultAuthorizationRequest {
    return RecordVaultAuthorizationRequestFromJSONTyped(json, false);
}

export function RecordVaultAuthorizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordVaultAuthorizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'termsVersion': json['termsVersion'],
        'termsSnapshot': json['termsSnapshot'],
        'acceptedTerms': json['acceptedTerms'],
    };
}

export function RecordVaultAuthorizationRequestToJSON(json: any): RecordVaultAuthorizationRequest {
    return RecordVaultAuthorizationRequestToJSONTyped(json, false);
}

export function RecordVaultAuthorizationRequestToJSONTyped(value?: RecordVaultAuthorizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'termsVersion': value['termsVersion'],
        'termsSnapshot': value['termsSnapshot'],
        'acceptedTerms': value['acceptedTerms'],
    };
}

